import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=3fe70985"
import script from "./TaskStatus.vue?vue&type=script&lang=js"
export * from "./TaskStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports